import { Component } from '@angular/core';

@Component({
  selector: 'no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.sass']
})
export class NoResultsComponent {}
